import { useEffect, useContext, useState } from 'react';
import { ScopeContext } from '@bingads-webui-react/scope-service';
import { connectToLinkedInCompanyPage } from '@bingads-webui-campaign-react/linkedin-data';

import { COMPANY_PAGE_LINKING_ACTIONS } from '../reducer';

export const useResendPermissionRequest = (state, dispatch, logger) => {
  const { scope } = useContext(ScopeContext);
  const { cid, aid } = scope.values;
  const [isProcessing, setIsProcessing] = useState(false);

  const { isResendingPermissionRequest, authorizationData, connectedCompanyPage } = state;

  useEffect(() => {
    if (isResendingPermissionRequest && !isProcessing) {
      setIsProcessing(true);
      connectToLinkedInCompanyPage(cid, aid, {
        authorizationData,
        companyPageID: connectedCompanyPage.Id,
      }).then(() => {
        logger.trace(`Permission request resent for company page ${connectedCompanyPage.Id}`);
        dispatch({ type: COMPANY_PAGE_LINKING_ACTIONS.PERMISSION_REQUEST_RESENT });
      }).catch((err) => {
        logger.trace(`Failed to resend permission request: ${JSON.stringify(err)}`);
        dispatch({ type: COMPANY_PAGE_LINKING_ACTIONS.PERMISSION_REQUEST_RESEND_FAILED, resendPermissionRequestError: err });
      }).finally(() => {
        setIsProcessing(false);
      });
    }
  }, [aid, authorizationData, cid, connectedCompanyPage, dispatch, isProcessing, isResendingPermissionRequest, logger]);
};
